(function () {
  function reduced() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function initSlider(root) {
    if (!root || root.dataset.urbInit === '1') return;
    root.dataset.urbInit = '1';

    var viewport = root.querySelector('[data-urb-viewport]');
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-urb-slide]')
    );
    var segs = Array.prototype.slice.call(
      root.querySelectorAll('[data-urb-seg]')
    );
    var fills = Array.prototype.slice.call(
      root.querySelectorAll('[data-urb-seg-fill]')
    );
    var prev = root.querySelector('[data-urb-prev]');
    var next = root.querySelector('[data-urb-next]');
    var count = slides.length;
    if (!viewport || count === 0) return;

    var duration = parseInt(root.dataset.urbDuration, 10) || 7000;
    var active = 0;
    var visible = false;
    var hovering = false;
    var programmatic = false;
    var rafId = 0;
    var startTime = 0;
    var idleTimer = null;

    function playVideo(index) {
      for (var n = 0; n < count; n++) {
        var video = slides[n].querySelector('video');
        if (!video) continue;
        if (n === index && !reduced()) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      }
    }

    function paint(activeFrac) {
      for (var n = 0; n < count; n++) {
        if (!fills[n]) continue;
        var w = n < active ? 100 : n > active ? 0 : activeFrac * 100;
        fills[n].style.width = w + '%';
        if (segs[n]) segs[n].classList.toggle('is-done', n < active);
      }
    }

    function stopProgress() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = 0;
    }

    function tick(now) {
      var frac = (now - startTime) / duration;
      if (frac >= 1) {
        paint(1);
        rafId = 0;
        goTo(active + 1 >= count ? 0 : active + 1);
        return;
      }
      paint(frac);
      rafId = requestAnimationFrame(tick);
    }

    function startProgress() {
      if (rafId) return;
      if (reduced()) {
        paint(1);
        return;
      }
      if (!visible || hovering || count < 2) return;
      startTime = performance.now();
      rafId = requestAnimationFrame(tick);
    }

    function setActive(index) {
      index = Math.max(0, Math.min(count - 1, index));
      active = index;
      for (var n = 0; n < count; n++) {
        slides[n].classList.toggle('is-active', n === index);
      }
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === count - 1;
      paint(0);
      playVideo(index);
    }

    function nearestIndex() {
      var center = viewport.scrollLeft + viewport.clientWidth / 2;
      var best = 0;
      var min = Infinity;
      for (var n = 0; n < count; n++) {
        var mid = slides[n].offsetLeft + slides[n].clientWidth / 2;
        var d = Math.abs(mid - center);
        if (d < min) {
          min = d;
          best = n;
        }
      }
      return best;
    }

    function scheduleSettle() {
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        programmatic = false;
        var idx = nearestIndex();
        if (idx !== active) setActive(idx);
        startProgress();
      }, 140);
    }

    function goTo(index) {
      index = Math.max(0, Math.min(count - 1, index));
      programmatic = true;
      stopProgress();
      setActive(index);
      startProgress();
      viewport.scrollTo({
        left: slides[index].offsetLeft,
        behavior: reduced() ? 'auto' : 'smooth'
      });
      scheduleSettle();
    }

    viewport.addEventListener(
      'scroll',
      function () {
        if (!programmatic) stopProgress();
        scheduleSettle();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchstart',
      function () {
        programmatic = false;
        stopProgress();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      function () {
        scheduleSettle();
      },
      { passive: true }
    );

    if (prev) prev.addEventListener('click', function () { goTo(active - 1); });
    if (next) next.addEventListener('click', function () { goTo(active + 1); });

    root.querySelectorAll('[data-urb-tap-prev]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(active - 1); });
    });
    root.querySelectorAll('[data-urb-tap-next]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(active + 1); });
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') goTo(active - 1);
      else if (e.key === 'ArrowRight') goTo(active + 1);
    });

    root.addEventListener('mouseenter', function () {
      hovering = true;
      stopProgress();
    });
    root.addEventListener('mouseleave', function () {
      hovering = false;
      scheduleSettle();
    });

    var down = false;
    var startX = 0;
    var startLeft = 0;

    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true;
      programmatic = false;
      startX = e.clientX;
      startLeft = viewport.scrollLeft;
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!down) return;
      root.classList.add('is-dragging');
      if (viewport.setPointerCapture) {
        try { viewport.setPointerCapture(e.pointerId); } catch (x) {}
      }
      viewport.scrollLeft = startLeft - (e.clientX - startX);
    });

    function endDrag(e) {
      if (!down) return;
      down = false;
      root.classList.remove('is-dragging');
      if (e && e.pointerId != null && viewport.releasePointerCapture) {
        try { viewport.releasePointerCapture(e.pointerId); } catch (x) {}
      }
      goTo(nearestIndex());
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    var sectionIo = new IntersectionObserver(
      function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) scheduleSettle();
        else stopProgress();
      },
      { threshold: 0.35 }
    );
    sectionIo.observe(root);

    setActive(0);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-urb-slider]');
    Array.prototype.forEach.call(roots, initSlider);
  }

  if (document.readyState !== 'loading') initAll();
  else
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();